import styled from 'styled-components';

const P = styled.p`
  white-space: pre-line;
`;

export { P };
